import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-lg container-fluid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "border-bottom mx-2 mt-3" }, " Track innovation progress and add milestones to the timeline ", -1)
const _hoisted_3 = { class: "timeline mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubBar = _resolveComponent("SubBar")!
  const _component_TimeLine = _resolveComponent("TimeLine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SubBar),
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_TimeLine, {
        loading: _ctx.loading,
        data: _ctx.data,
        size: true
      }, null, 8, ["loading", "data"])
    ])
  ]))
}